import $ from "jquery";
import Helpers from "../utilities/helpers";

/**
 * Will hold references to the currently playing audio clips.
 * 
 * @var {[hash:string]:Audio}
 */
var playingAudioClips = {};

/**
 * 
 */
export default function DictionaryModals() {
    $( initDictionaryModalsAudio );
}

/**
 * Initialises the dictionary modal popups.
 */
export function initDictionaryModalsAudio() {
    // Ensure there is support available for the `Audio` library in the browser before initialising the audio player.
    if ( window[ 'Audio' ] ) {
        $( ".audio-button" ).on( "click", onClickAudioButton );
    } else { 
        $( ".audio-button" ).addClass( "hidden" ); // Otherwise hide the element as it will be non-functional.
    }
}

/**
 * On click the audio button.
 */
function onClickAudioButton( event ) { 
    // Get the target element and check it.
    let $target = $( event.target ?? this );

    if ( ! $target.length ) {
        return;
    }

    if ( ! $target.data( "audio-clip" ) ) {
        $target = $target.parents( "button[data-audio-clip]" );
    }

    // Get audio file.
    const audioFile = $target.data( "audio-clip" );

    // Ensure there's an audio clip we can actually play.
    if ( ! audioFile || ! audioFile.length ) {
        return;
    }

    // Hash the name of the audio clip to become the object key in the playing tracking var.
    var fileHash = Helpers.hash( audioFile );

    // Check if already playing
    const playing = !! playingAudioClips[ fileHash ];

    // If the file isn't already playing then make it so.
    if ( ! playing ) {
        playingAudioClips[ fileHash ] = new Audio( audioFile );
        playingAudioClips[ fileHash ].play();
        playingAudioClips[ fileHash ].addEventListener( "ended", () => { 
            playingAudioClips[ fileHash ] = null;

            delete playingAudioClips[ fileHash ];

            $target.children( "svg" ).children( "path" ).removeClass( "fill-theme-blue" );
        } )

        $target.children( "svg" ).children( "path" ).addClass( "fill-theme-blue" );
    } else { 
        // Otherwise stop it, when it's not already stopped itself.
        if ( ! playingAudioClips[ fileHash ] ) {
            return;
        }

        playingAudioClips[ fileHash ].pause();
        playingAudioClips[ fileHash ] = null;
        delete playingAudioClips[ fileHash ];

        $target.children( "svg" ).children( "path" ).removeClass( "fill-theme-blue" );
    }

}